import axios from "axios"

import { GeolocationAutocompleteType, GeolocationPlaceType } from "./types"

type GeoTypes = "geocode" | "locality"

const API_ACCESS_KEY = process.env.REACT_APP_FORCE4_API_ACCESS_KEY ?? ""

export const GeoService = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
})
GeoService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    return Promise.reject(error)
  },
)

const autocomplete = (q: string, types: GeoTypes = "geocode", lang = "pl") =>
  GeoService.get<null, GeolocationAutocompleteType[]>(
    `https://common.api.force4.ai/geocoding/autocomplete?q=${q}&types=${types}&lang=${lang}`,
    {
      headers: { "X-Access-Key": API_ACCESS_KEY },
    },
  )

const place = (id: string, lang = "pl") =>
  GeoService.get<null, GeolocationPlaceType>(
    `https://common.api.force4.ai/geocoding/place?id=${id}&lang=${lang}`,
    {
      headers: { "X-Access-Key": API_ACCESS_KEY },
    },
  )

export const GeolocationService = {
  autocomplete,
  place,
}
